<template>
  <el-container v-loading="isLoading">
    <HttpRecordDetail v-if="record" :record="record" />
  </el-container>
</template>

<script>
import HttpRecordDetail from "@/components/HttpRecordDetail.vue";
import axios from "axios";

export default {
  components: {
    HttpRecordDetail
  },
  data: function() {
    return {
      record: null,
      isLoading: true
    };
  },
  created: function() {
    this.fetchRecord();
  },
  watch: {
    $route(to, from) {
      this.fetchRecord();
    }
  },
  methods: {
    fetchRecord() {
      this.isLoading = true;
      let url =
        "/api/v1/project/" +
        this.$route.params.api_key +
        "/http_record/" +
        this.$route.params.record_id + '/';
      axios({ url: url, method: "GET" })
        .then(resp => {
          this.record = resp.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>


